type ErrorMessageType = {
    requiredMsg: string;
    invalidMsg: string;
}

type AppUrlsType = {
    entrepriseLoginPage: string;
    entrepriseForgetPassPage: string;
    entrepriseInitPassPage: string;
}
type SessionStorageKeyType = {
    initPassToken: string;
}


export const ERROR_MESSAGES: ErrorMessageType = {
    requiredMsg: "Veuillez renseigner cette information",
    invalidMsg: "L'information renseignée semble incorrecte"
}

export const SESSION_STORAGE_KEYS: SessionStorageKeyType = {
    initPassToken: "initPassToken_",
}